import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getCellDesigns } from '../../../helpers/cellDesign';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
// import { getProductType } from '../../../helpers/getProductType';
// import { getRequiredDepthByProductTypeAndCellDesign } from '../../../helpers/getRequiredDepthByProductTypeAndCellDesign';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  cellDesign: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (cellDesign, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      cellDesign,
    },
  });

export const CellDesign = () => {
  const [state, send] = useService(productBuilderMachine);
  const { cellDesign } = state.context.custom;
  const cellDesignOptions = getCellDesigns(state.context);
  const productType = getBaseProductType(state.context);

  if (isCurrentState('cellDesign', state) && cellDesignOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Cell Size</Heading>
      <Caption>Choose the look of your honeycomb</Caption>
      <Selector isSlider={true}>
        {cellDesignOptions.map(option => {
          const isSelected = option === cellDesign;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'cellDesign',
            option,
          );

          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
